var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flexs jc-c back-f padding-t-60 padding-b-60"
  }, [_vm._m(0), _c('div', {
    staticClass: "flexs column"
  }, [_c('div', {
    staticClass: "flexs fs-16 c-3 line-60"
  }, [_c('span', {
    staticClass: "margin-r-80"
  }, [_vm._v("邮箱：" + _vm._s(_vm.email))]), _c('span', [_vm._v("联系电话：" + _vm._s(_vm.mobile))])]), _c('div', {
    staticClass: "footer"
  }, [_vm._v(" 晋ICP备2025062270号 Copyright© 2025 聚猫（山西）科技有限公司 Al Rights Reserved. ")])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flexs jc-c al-c margin-l-100 margin-r-100"
  }, [_c('img', {
    staticClass: "w-32 h-32 se-c margin-r-10",
    attrs: {
      "src": require("../../assets/images/logo.jpg")
    }
  }), _c('span', {
    staticClass: "fs-30 c-0 f-700"
  }, [_vm._v("AdJM")])]);
}];
export { render, staticRenderFns };